import React, { useState, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextEditor = () => {
    // Default formatted text with placeholders
    const defaultText = `<h2 style="color: #01103B;">Good afternoon [Client Name]</h2>
        <p><strong>This is to inform you we had been unable to collect your vehicle due to the following reason:</strong></p>
        <ul>
            <li>Bullet Point 1</li>
            <li>Bullet Point 2</li>
        </ul>
        <p>We made the call yesterday and provide the details below:</p>
        <ul>
            <li><strong>Date of call:</strong> [DateOfCall]</li>
            <li><strong>Name of contacted person prior to collection:</strong></li>
            <li><strong>Name of dealer on site:</strong></li>
            <li><strong>Collection Date:</strong> [CollectionDate]</li>
        </ul>`;

    const [value, setValue] = useState(defaultText);
    const [dateOfCall, setDateOfCall] = useState("");
    const [collectionDate, setCollectionDate] = useState("");
    const quillRef = useRef(null);

    // Function to replace placeholders in the text
    const updateTextWithDate = (type, selectedDate) => {
        if (selectedDate) {
            const formattedDate = selectedDate.split("-").reverse().join("/"); // Convert YYYY-MM-DD to DD/MM/YYYY
            let updatedText = value;

            if (type === "DateOfCall") {
                updatedText = updatedText.replace("[DateOfCall]", formattedDate);
                setDateOfCall(selectedDate);
            } else if (type === "CollectionDate") {
                updatedText = updatedText.replace("[CollectionDate]", formattedDate);
                setCollectionDate(selectedDate);
            }

            setValue(updatedText);
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean']
        ]
    };

    return (
        <div>
            <h2>Rich Text Editor</h2>
            <ReactQuill ref={quillRef} value={value} onChange={setValue} modules={modules} />

            <h3>Select Dates:</h3>
            <label><strong>Date of Call:</strong></label>
            <input 
                type="date" 
                value={dateOfCall} 
                onChange={(e) => updateTextWithDate("DateOfCall", e.target.value)} 
            />
            
            <br /><br />
            
            <label><strong>Collection Date:</strong></label>
            <input 
                type="date" 
                value={collectionDate} 
                onChange={(e) => updateTextWithDate("CollectionDate", e.target.value)} 
            />

            <h3>Preview:</h3>
            <div dangerouslySetInnerHTML={{ __html: value }} />
        </div>
    );
};

export default TextEditor;
